/**
 * Global styles for fund details and fund creation components
 * Provides consistent styling across the application
 */
export const GLOBAL_STYLES = {
  header:
    'w-full text-typography-neutral-deep text-font-size-heading-h5 leading-line-height-heading-h5 font-semibold pb-measure-xl border-b border-border-neutral-soft',
  section: 'flex flex-col gap-measure-lg',
  emptyStateContainer: 'flex items-center justify-center',

  sectionTitle:
    'w-full text-typography-neutral-deep text-font-size-paragraph-lg leading-line-height-paragraph-lg font-semibold pb-measure-xl border-b border-border-neutral-soft',
  grid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-measure-lg gap-y-measure-lg',
  gridMedium:
    'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-measure-lg gap-y-measure-lg',
  gridLarge:
    'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-measure-lg gap-y-measure-lg',
  field: 'flex flex-col gap-measure-sm py-measure-sm px-measure-2xs',
  fieldTitle:
    'text-font-size-paragraph-xs font-medium text-typography-neutral-strong leading-line-height-paragraph-xs',
  fieldValue:
    'text-font-size-label-lg text-typography-neutral-deep leading-line-height-label-lg font-medium',
  spaceYContainer: 'space-y-measure-4xl',
  spaceYSection: 'space-y-measure-lg',
  spaceYHeader: 'space-y-measure-2xs',
  pageContainer:
    'min-h-full py-measure-lg px-measure-lg md:py-measure-2xl md:px-measure-2xl lg:py-measure-2xl lg:px-measure-4xl flex flex-col gap-measure-4xl',
  actionButtonsContainer:
    'flex flex-col md:flex-row justify-between gap-measure-lg py-measure-lg px-measure-lg md:py-measure-2xl md:px-measure-2xl lg:py-measure-lg lg:px-measure-4xl rounded-lg',
  badgeDetails:
    'px-measure-sm py-measure-3xs border-none text-font-size-label-md leading-line-height-label-md font-medium rounded-3xl',
  badgeOverview:
    'px-measure-3xs py-measure-5xs border-none text-font-size-label-sm leading-line-height-label-sm font-medium rounded-3xl',
  labelXs:
    'text-font-size-label-xs text-typography-neutral-primary leading-line-height-label-xs tracking-letter-spacing-label-xs font-normal',
  paragraphSm:
    'text-font-size-paragraph-sm text-typography-neutral-deep leading-line-height-paragraph-sm tracking-letter-spacing-paragraph-sm font-semibold',
  paragraphXs:
    'text-font-size-paragraph-xs leading-line-height-paragraph-xs tracking-letter-spacing-paragraph-xs',
  labelMd:
    'text-typography-neutral-primary text-font-size-label-md leading-line-height-label-md font-medium',
  headingH3:
    'text-typography-neutral-deep text-font-size-heading-h3 leading-line-height-heading-h3 font-semi-bold',
  modal: {
    modalClass: '!w-[23.4375rem] !bg-surface-bg-generic-white',
    mediaClass: '!mb-measure-sm',
    contentClass: '!text-center !gap-measure-4xs',
    titleClass:
      'text-typography-neutral-deep text-font-size-paragraph-lg leading-line-height-paragraph-lg tracking-letter-spacing-paragraph-lg font-semibold wrap-break-word',
    messageClass:
      'text-typography-neutral-primary text-font-size-label-md leading-line-height-label-md tracking-letter-spacing-label-md font-medium wrap-break-word',
    buttonsClass:
      '!flex !flex-col !w-full !items-stretch !gap-measure-sm !mt-measure-2xl',
  },
} as const;

export type IGlobalStyles = (typeof GLOBAL_STYLES)[keyof typeof GLOBAL_STYLES];
